import { BookOutlined, CalendarOutlined, DollarOutlined, FileTextOutlined, FolderOpenOutlined, FormOutlined, LineChartOutlined, LockOutlined, ScheduleOutlined, SettingOutlined, TeamOutlined, UsergroupAddOutlined } from "@ant-design/icons";

export const admissionsModules = {
    'Manage Applications': [
        'Document Requirements',
        'Exam Schedule Requests',
        'Exam Results',
        'Enrollment Period',
    ],
    'Manage Queue': [],
    'Create Announcements': [],
};

export const registrarModules = {
    'Manage Student Records': [],
    'Manage Enrollment': [],
    'Manage Schedule': [],
    'Manage Program': [
        'Strands',
        'Subjects',
        'Sections',
    ],
    'Manage Queue': [],
    'Create Announcements': [],
};

export const accountingModules = {
    'Manage Payments': [
        'Fee Structure',
        'User Ledger',
        'Payment History',
    ],
    'Manage Queue': [],
    'Create Announcements': [],
};

export const subAdminModules = {
    'Manage Accounts': [],
    'Manage Schedule': [],
    'Manage Program': [
        'Manage Strands',
        'Manage Subjects',
        'Manage Sections',
    ],
    'Manage Student Records': [],
    'Manage Enrollment': [],
    'Manage Payments': [
        'Fee Structure',
        'User Ledger',
        'Payment History',
    ],
    'System Logs': [],
    'Create Announcements': [],
};

// Define all staff modules for the super admin
export const allStaffModules = {
    'Manage Applications': [
        'Document Requirements',
        'Exam Schedule Requests',
        'Exam Results',
        'Enrollment Period',
    ],
    'Manage Accounts': [],
    'Create Announcements': [],
    'Manage Enrollment': [],
    'Manage Schedule': [],
    'System Logs': [],
    'Manage Payments': [
        'Fee Structure',
        'User Ledger',
        'Payment History',
    ],
    'Manage Program': [
        'Strands',
        'Subjects',
        'Sections',
    ],
    'Manage Queue': [],
    'Manage Student Records': [],
};

export const defaultRoleModules = {
    Faculty: {
        'Class Schedule': [],
        'Class Information': [],
        'Handling of Grades': [],
        'Viewing of OTE': [],
    },
    Student: {
        'Student Handbook': [],
        'Certificate of Registration': [],
        'Flowchart': [],
        'Online Class Registration': [],
        'Viewing of Grades': [],
        'Class Schedule': [],
        'Online Teacher\'s Evaluation': [],
        'Student Ledger': [],
        'Enrollment': [],
        'Joining Queue': [],
        'Pay Bills': [],
    },
    'Admissions (Staff)': admissionsModules,
    'Registrar (Staff)': registrarModules,
    'Accounting (Staff)': accountingModules,
    'Administration (Sub-Admin)': subAdminModules,
    'IT (Super Admin)': allStaffModules,
};


